// extracted by mini-css-extract-plugin
module.exports = {"background":"image-background-module--background--hs6HP"};